import HasID from "./HasID";
import {create, Delta} from "jsondiffpatch";

export interface History extends HasID {
    oldValue: string;
    newValue: string;
    updated: Date;
    updatedBy: string;
    noMeaningfulChanges?: boolean;
}

export function historyDiff(history: History): Delta | undefined {
    const jsondiffpatch = create({
        textDiff: {
            minLength: Number.MAX_VALUE  // Disable text diffing - always use [old, new] format
        },
        propertyFilter: function(name: string) {
            if (name == "Updated") return false;
            if (name == "UpdatedBy") return false;
            return true;
        },
        objectHash: function(obj: any, index: number) {
            // Use TaskQuestionId as the unique identifier for TaskAnswers
            if (obj.TaskQuestionId !== undefined) {
                return obj.TaskQuestionId;
            }
            // Use TaskId for TaskPatients, TaskPrescriptions, TaskAssignments
            if (obj.TaskId !== undefined) {
                return obj.TaskId;
            }
            // Use state abbreviation as the unique identifier for StateOptions
            if (obj.State !== undefined || obj.state !== undefined) {
                return obj.State || obj.state;
            }
            // Default to array index
            return '$$index:' + index;
        }
    });

    let oldValue: any;
    if (history.oldValue) oldValue = JSON.parse(history.oldValue)[0];
    const newValue = JSON.parse(history.newValue)[0];

    // Parse JSON string fields that are stored as serialized arrays in the database
    const jsonStringFields = ['StateOptions', 'stateOptions'];
    jsonStringFields.forEach(field => {
        if (oldValue && typeof oldValue[field] === 'string') {
            try {
                oldValue[field] = JSON.parse(oldValue[field]);
            } catch { /* ignore parse errors */ }
        }
        if (newValue && typeof newValue[field] === 'string') {
            try {
                newValue[field] = JSON.parse(newValue[field]);
            } catch { /* ignore parse errors */ }
        }
    });

    Object.keys(newValue).forEach((h : any) => {
        if (Array.isArray(newValue[h]) && oldValue && !oldValue[h])
            oldValue[h] = [];
    })

    Object.keys(oldValue ?? {}).forEach((h : any) => {
        if (Array.isArray(oldValue[h]) && !newValue[h])
            newValue[h] = [];
    })

    return jsondiffpatch.diff(oldValue, newValue);
}
